import { RootState } from 'redux/store';

export const unreadNotificationSelector = (state: RootState) => state.notifications.unreadNotifications;
export const readNotificationSelector = (state: RootState) => state.notifications.readNotifications;
export const unreadNotificationCountSelector = (state: RootState) => state.notifications.unreadCount;
export const readNotificationCountSelector = (state: RootState) => state.notifications.readCount;
export const notificationStatusSelector = (state: RootState) => state.notifications.status;
